<h3 *ngIf="!isSdfCardFlow" class="mg-step-header gffp-header">
  {{ labels?.stellar?.gffp?.header }}
</h3>
<h3 *ngIf="isSdfCardFlow" class="card-gffp-header">
  {{ sdfCardLabels?.common?.idDetails }}
</h3>
<ng-container
  *ngFor="let sectionConfig of formConfigs; let sectionIndex = index"
>
  <h4 class="mg-section-title" *ngIf="sectionConfig.title">
    {{ sectionConfig.title }}
  </h4>
  <div class="app-form-container">
    <app-forms [config]="sectionConfig.config" [labels]="labels"></app-forms>
  </div>
</ng-container>

<div *ngIf="!isSdfCardFlow" class="info-div">
  <img src="assets/images/icn-id.png" alt="ID icon" />
  <!-- <span>Be sure to <b>bring the Photo ID</b> you used for this transaction with you to the store.</span> -->
  <span [innerHTML]="labels.stellar.gffp.reminderText"></span>
</div>

<div *ngIf="isSdfCardFlow" class="inline-notification-wrapper">
  <div class="content-container">
    <img
      src="assets/images/photo-id-icon.svg"
      alt="info-icon"
      class="info-icon"
    />
    <p class="content-body">{{ sdfCardLabels?.common?.notifcation?.one }}.</p>
  </div>
</div>

<div class="mg-step-actions-row">
  <button
    color="primary"
    mat-raised-button
    (click)="submitGffp()"
    [disabled]="isInvalid"
  >
    <span *ngIf="!isSdfCardFlow">{{ labels?.stellar?.next }}</span>
    <span *ngIf="isSdfCardFlow">{{ sdfCardLabels?.common?.continue }}</span>
  </button>
</div>
